import { render, staticRenderFns } from "./CardAmountEdit.vue?vue&type=template&id=31456d5a&scoped=true&"
import script from "./CardAmountEdit.vue?vue&type=script&lang=js&"
export * from "./CardAmountEdit.vue?vue&type=script&lang=js&"
import style0 from "./CardAmountEdit.vue?vue&type=style&index=0&id=31456d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31456d5a",
  null
  
)

export default component.exports